import resize from '../resize';
import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper';
Swiper.use([Navigation, Pagination, Scrollbar]);

const initProgrammSlider = () => {
  const slider = document.querySelector('.programNew__swiper'),
    body = document.body;

  let swiper = null;

  function init() {
    if (!swiper) {
      swiper = new Swiper(slider, {
        direction: 'vertical',
        slidesPerView: 1,
        spaceBetween: 8,
        height: 50,
        freeMode: true,
        scrollbar: {
          el: '.programNew-scrollbar',
          draggable: true,
          dragSize: '119',
          snapOnRelease: true,
        },
        mousewheel: true,

        on: {
          init: slider.addEventListener('wheel', function (e) {
            if (e.deltaY < 0) {
              swiper.slidePrev();
            } else {
              swiper.slideNext();
            }
          }),
          init: slider.addEventListener('mouseover', function (e) {
            body.addEventListener('wheel', preventScroll, { passive: false });
          }),
          init: slider.addEventListener('mouseout', function () {
            body.removeEventListener('wheel', preventScroll, {
              passive: false,
            });
          }),
        },
      });

      function preventScroll(e) {
        e.preventDefault();
       // e.stopPropagation();

        return false;
      }
    }
  }

  function destroy() {
    if (swiper) {
      swiper.destroy();
      swiper = null;
    }
  }

  function resizeSwiper() {
    destroy();
    init();
  }

  slider && resizeSwiper();
  slider && resize(resizeSwiper);
};

export default initProgrammSlider;
